import { Routes, Route } from 'react-router-dom';
import './App.css';
import Main from './Main';
import VulnerabilityDisclosurePolicy from './pages/VulnerabilityDisclosurePolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import RouteEffects from './components/RouteEffects';
import { useSmoothScroll } from './hooks/useSmoothScroll';

function App() {
  useSmoothScroll();

  return (
    <div className="App" lang="en">
      <RouteEffects />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/vulnerability-disclosure-policy" element={<VulnerabilityDisclosurePolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      </Routes>
    </div>
  );
}

export default App;
